document.addEventListener('DOMContentLoaded', () => {
    const horizontalScrollController = new HorizontalScrollController(".projekt__konzept-wrap", ".header__menuepunkt", ".projekt__projekt", ".projekt__projekte");

    document.querySelectorAll('.projekt__projektinfo a').forEach(link => {
        link.setAttribute('data-cursor', 'kreuz');
    });
   
    // The Farbwechsler must not be called before the scroller is initialised
    horizontalScrollController.initHorizontalScroll().then(() => {
        console.log('setupHorizontalScroll.then');

        const farbwechslerLogo = new Farbwechsler({
            trigger: "#entstehung",
            text: ".header__element--logo",
            containerText: ".header__element-link",
            slider: ".projekt__konzept-wrap"
        });
        const farbwechslerMenuepunkte = new Farbwechsler({
            trigger: "#entstehung",
            buttons: ".header__menuepunkt",
            slider: ".projekt__konzept-wrap"
        });
        
        const farbwechslerMenue = new Farbwechsler({
            trigger: "#entstehung",
            buttons: ".menue__link",
            slider: ".projekt__konzept-wrap"
        });
        
        const farbwechslerBeschriftung = new Farbwechsler({
            trigger: "#entstehung",
            text: ".projekt__beschriftung", 
            containerText: ".projekt__beschriftung",
            slider: ".projekt__konzept-wrap" 
        });



        setTimeout(() => {
            console.log('farbwechslerLogo.farbeWechselnTextMitContainer');
            farbwechslerLogo.farbeWechselnTextMitContainer();
            console.log('farbwechslerMenuepunkte.farbeWechselnText');
            farbwechslerMenuepunkte.farbeWechselnText();
            console.log('farbwechslerMenue.farbeWechselnText');
            farbwechslerMenue.farbeWechselnText();
            const viewportObserver = new ViewportObserver((viewport) => {
                if (viewport === 'desktop') {
                    farbwechslerBeschriftung.killTimeline();
                    farbwechslerBeschriftung.farbeWechselnTextMitContainer();
                }
            });
            viewportObserver.callback(viewportObserver.currentViewport);
        }, 50);
        
    });
    
});
